import React from 'react';
import './CtaFinal.css';

function CtaFinal() {
  return (
    <div>
      <div class="cta-wrapper">
        <div className='cta-container'>
          <h2>Ficou com alguma dúvida que não foi esclarecida?</h2>
          <p>Clique no botão abaixo e fale com o Professor Pedro da Mata.</p>
          <a className='main-btn' target='_blank' rel='noreferrer' href="https://wa.link/vtjt4w">TIRAR DÚVIDAS COM O PROF. PEDRO</a>
        </div>
        <div className='footer'>
          <p>Todos os direitos reservados – Insigne Acadêmica.</p>
        </div>
            </div>
      </div>
  );
}

export default CtaFinal;
